export default __webpack_public_path__ + "media/nrk-calendar-51b4V.svg";